import ErpHeaderLoggedIn from './ErpHeaderLoggedIn';
import TikklokDebug from './TikklokDebug';
import ProfileGroupList from './profileGroups/ProfileGroupList';
import SettingsWorkstationTypes from './workstations/SettingsWorkstationTypes';
import QrScanner from './QrScanner';
import HideMessage from './dialogs/HideMessage';
import InputDialog from './dialogs/InputDialog';
import SawlineEdit from './sawlines/SawlineEdit';
import Vue from 'vue';
import DateModalContainer from './modals/DateModalContainer';
import RunningTasks from './RunningTasks';

Vue.component('sawline-edit', SawlineEdit);

export default {
    ErpHeaderLoggedIn,
    TikklokDebug,
    ProfileGroupList,
    SettingsWorkstationTypes,
    QrScanner,
    DateModalContainer,
    HideMessage,
    InputDialog,
    RunningTasks,
};
